
import axios from "axios"
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class PODocStore extends ApiStore{
  constructor() {

    super();
  }

  newPODoc(completeFunc){
    axios.get('/purchaseorder/doc/?format=json&new_po=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPODoc(poNo,completeFunc){
    axios.get('/purchaseorder/doc/?format=json&po='+poNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  // loadPODoc(poNo,from,completeFunc){
  //   axios.get('/purchaseorder/doc/?format=json&po='+poNo+'&ref_menu='+from)
  //   .then(function(response){
  //     console.log(response)
  //     completeFunc(response.data)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   })
  // }

  loadPORequestDoc(poNo,new_po,from,completeFunc){
    axios.get('/purchaseorder/request_doc?pr='+poNo+'&format=json&new_po='+new_po+'&ref_menu='+from)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSupplier(shopId,completeFunc){
    axios.get('/purchaseorder/supplier/'+shopId)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSupplierList(query,pageNo,completeFunc){
    axios.get('/purchaseorder/supplierlist/?format=json&q='+query+'&page='+pageNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  savePODoc(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/purchaseorder/doc/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  updatePODocStatus(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/purchaseorder/status/',querystring.stringify(postData))
    .then(function(response){
      console.log('response',response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }
  
  delSupplier(customerId,completeFunc,errorFunc){
    
    console.log('supplier',customerId)
    axios.delete('/purchaseorder/supplier/'+customerId)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delPODoc(poNo,completeFunc,errorFunc){
    
    console.log('doc',poNo)
    poNo = poNo.replace("/", "_");
    axios.delete('/purchaseorder/doc/'+poNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveSupplier(postData,completeFunc,errorFunc){
    
    //console.log('postData',postData)
    axios.post('/purchaseorder/supplier/'+postData.shop_id,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadPORecord(recordType,poNo,completeFunc){
    axios.get('/purchaseorder/purchase_record?po='+poNo+'&type='+recordType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPOOutRecord(recordType,poNo,completeFunc){
    axios.get('/purchaseorder/purchase_outstanding_record?po='+poNo+'&type='+recordType)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPurchaseReceivedRecord(poNo,completeFunc) {
    axios.get('/purchaseorder/purchase_received_record?po='+poNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPurchaseImportedRecord(poNo,completeFunc) {
    axios.get('/purchaseorder/purchase_imported_record?po='+poNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  savePORecord(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/purchaseorder/purchase_record/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.result==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  

  updatePODocPaymentStatus(poNo,completeFunc,errorFunc){   
    axios.post('/purchaseorder/payment_status?po='+poNo)
    .then(function(response){
      console.log('response',response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  } 

  updatePODocExportWorkStatus(poNo,completeFunc,errorFunc){   
    axios.post('/purchaseorder/exportwork_status?po='+poNo)
    .then(function(response){
      console.log('response',response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  loadFup(po, cat, completeFunc) {
    axios.get('/purchaseorder/images?po='+po)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadWorkRecord(workNo,completeFunc){
    axios.get('/purchaseorder/work_record?wo='+workNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  updatePOFromPRStatus(prNo,status,completeFunc,errorFunc){
    axios.post('/purchaseorder/request_doc_po_status/'+status+'?pr='+prNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  rejectReasonPOStatus(prNo,status,postData,completeFunc,errorFunc){
    axios.post('/purchaseorder/request_doc_po_status/'+status+'?pr='+prNo,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadNewPartPriceCompareDoc(completeFunc){
    axios.get('/purchaseorder/partpricecompare_doc?format=json&new_ppc=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPartPriceCompareDoc(ppc,completeFunc){
    axios.get('/purchaseorder/partpricecompare_doc?format=json&new_ppc=false&ppc='+ppc)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  savePartPriceCompareDoc(ppc,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/purchaseorder/partpricecompare_doc?ppc='+ppc,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadNewPriceCompareDoc(completeFunc){
    axios.get('/purchaseorder/pricecompare_doc?format=json&new_pc=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPriceCompareDoc(pc,completeFunc){
    axios.get('/purchaseorder/pricecompare_doc?format=json&new_pc=false&pc='+pc)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  savePriceCompareDoc(pc,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/purchaseorder/pricecompare_doc?pc='+pc,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadFupPriceCompare(docNo,cat,param,completeFunc) {
    axios.get('/purchaseorder/'+cat+'?'+param+'='+docNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }
}

export default new PODocStore()



// WEBPACK FOOTER //
// ./src/stores/PODocStore.js